import React from 'react';

export const FeatureLabels = [
  {
    title: '品牌赋能',
    subTitle: '滴滴品牌背书，提升桩企影响力',
    children: [
      {
        title: '好桩推荐',
        href: 'https://s3-gz01.didistatic.com/packages-mait/img/XwYPbupsN81766988508519.png',
        hint: '坚持免费、公平、高效的准则，向全平台商户宣传优质桩企，助力桩企提升品牌曝光。',
        omega: {
          id: 'charge_cpcp_abilities1_tab1_sw',
          remark: '桩企平台首页_1品牌赋能_1好桩推荐_曝光'
        }
      },
      {
        title: '品牌沙龙',
        href: 'https://s3-gz01.didistatic.com/packages-mait/img/QcDkmUfklT1766993023062.png',
        hint: (
          <div>
            <div>滴滴充电联合桩企、运营商、储能、虚拟电厂等行业生态伙伴，举办线下沙龙活动。</div>
            <div style={{height: 8}}></div>
            <div>桩企可通过活动发布新品/技术，借势扩大行业影响力，同时高效转化优质商机。</div>
          </div>
        ),
        omega: {
          id: 'charge_cpcp_abilities1_tab2_sw',
          remark: '桩企平台首页_1品牌赋能_2品牌沙龙_曝光'
        }
      },
    ],
  },
  {
    title: '智能桩解决方案',
    subTitle: '智能化升级，4大卖点提升竞争力',
    children: [
      {
        title: '极速启动',
        href: 'https://view.didistatic.com/static/dcms/n1t0hrvmefl0x0n_1520x1000.png',
        hint: (
          <div>
            <div>用户插枪扫码，即可5s极速启动充电。</div>
            <div style={{height: 8}}></div>
            <div>对比传统扫码充电需等待30s~60s的启动时间，极速启动可大幅度缩短用户等待时长，提升充电体验。</div>
          </div>
        ),
        omega: {
          id: 'charge_cpcp_abilities2_tab1_sw',
          remark: '桩企平台首页_2智能桩解决方案_1极速启动_曝光'
        }
      },
      {
        title: '智能加速',
        href: 'https://view.didistatic.com/static/dcms/144p2r1z3brmefl0zag_1520x1000.png',
        hint: '智能策略可实现高峰期整站充电提速约8%，高峰期设备翻台率更高，提升商户经营收益。',
        omega: {
          id: 'charge_cpcp_abilities2_tab2_sw',
          remark: '桩企平台首页_2智能桩解决方案_2智能加速_曝光'
        }
      },
      {
        title: '运维管家',
        href: 'https://s3-gz01.didistatic.com/packages-mait/img/5CVjfhRbTq1766988612647.png',
        hint: (
          <div>
            <div>系统实时巡检，高异常设备自动创建工单同步商户&桩企，减少商户线下排查频次。</div>
            <div style={{height: 8}}></div>
            <div>匹配智能策略，25.3%的设备故障，无需线下维修可实现远程自愈，降低商户&桩企运维成本。</div>
          </div>
        ),
        omega: {
          id: 'charge_cpcp_abilities2_tab3_sw',
          remark: '桩企平台首页_2智能桩解决方案_3运维管家_曝光'
        }
      },
      {
        title: '电池卫士',
        href: 'https://view.didistatic.com/static/dcms/gnbmf0ssomefldh1s_1520x1000.png',
        hint: (
          <div>
            <div>四级安全防护体系+17项安全防护模型，全方位守护充电安全，助力场站安全运营。</div>
            <div style={{height: 8}}></div>
            <div>平台安全能力持续升级，24年千万订单事故数对比21年下降82%。</div>
          </div>
        ),
        omega: {
          id: 'charge_cpcp_abilities2_tab4_sw',
          remark: '桩企平台首页_2智能桩解决方案_4电池卫士_曝光'
        }
      },
    ],
  },
  {
    title: '售前提效',
    subTitle: '接入快、上线快、高兼容',
    children: [
      {
        title: '快速接入',
        href: 'https://s3-gz01.didistatic.com/packages-mait/img/uY3hWpJgxz1766993148433.png',
        hint: (
          <div>
            <div>一站式接入工作台，平台免费技术支持，专人答疑。</div>
            <div style={{height: 8}}></div>
            <div>多种对接协议，适用不同桩企接入需求。</div>
          </div>
        ),
        omega: {
          id: 'charge_cpcp_abilities3_tab1_sw',
          remark: '桩企平台首页_3售前提效_1快速接入_曝光'
        }
      },
      {
        title: '多平台选择',
        href: 'https://s3-gz01.didistatic.com/packages-mait/img/4IpWQu1o2K1766993234168.png',
        hint: (
          <div>
            <div>多平台支持不同类型的客户诉求：</div>
            <div style={{height: 8}}></div>
            <div>滴滴充电平台版：海量流量优势，平台专人代运营，客户省心托管。</div>
            <div style={{height: 8}}></div>
            <div>小桔慧充平台版：0抽佣，灵活合作，合同1年起签。</div>
            <div style={{height: 8}}></div>
            <div>企业版SaaS：助力国央企，打造自主可控的运营平台。</div>
            <div style={{height: 8}}></div>
            <div>多种对接协议，适用不同桩企接入需求。</div>
          </div>
        ),
        omega: {
          id: 'charge_cpcp_abilities3_tab2_sw',
          remark: '桩企平台首页_3售前提效_2多平台选择_曝光'
        }
      },
      {
        title: '多样对接服务',
        href: 'https://view.didistatic.com/static/dcms/gnbmf0ssmmefnobwq_1520x1000.png',
        hint: (
          <div>
            <div>专业商务团队，助力桩企项目高效落地。</div>
            <div style={{height: 8}}></div>
            <div>高效对接政府平台，保障商户领取补贴收益。</div>
            <div style={{height: 8}}></div>
            <div>免费对接道闸平台，实现场站充电停车减免服务。</div>
          </div>
        ),
        omega: {
          id: 'charge_cpcp_abilities3_tab3_sw',
          remark: '桩企平台首页_3售前提效_3多样对接服务_曝光'
        }
      },
    ],
  },
  {
    title: '售后降本',
    subTitle: '4大功能，让售后更省钱',
    children: [
      {
        title: '运维工作台',
        href: 'https://view.didistatic.com/static/dcms/144p2r192remefnrnd9_1520x1000.png',
        hint: '​一站式运维工作台，提供设备大盘监控、模块诊断、故障分析、OTA升级等功能，助力桩企高效管理。',
        omega: {
          id: 'charge_cpcp_abilities4_tab1_sw',
          remark: '桩企平台首页_4售后降本_1运维工作台_曝光'
        }
      },
      {
        title: '异常识别诊断',
        href: 'https://view.didistatic.com/static/dcms/144p2r192kvmefnshsi_1520x1000.png',
        hint: (
          <div>
            <div>异常设备识别率99%，准确率95%，识别异常后自动创建工单同步桩企与商户。</div>
            <div style={{height: 8}}></div>
            <div>设备上报数据更全，覆盖充电模块、充电枪等9大易损件，辅助诊断率60.5%，诊断准确率87%。</div>
            <div style={{height: 8}}></div>
            <div>提供小桔慧修小程序，支持移动端实时运维。</div>
          </div>
        ),
        omega: {
          id: 'charge_cpcp_abilities4_tab2_sw',
          remark: '桩企平台首页_4售后降本_2异常识别诊断_曝光'
        }
      },
      {
        title: '设备故障自愈',
        href: 'https://view.didistatic.com/static/dcms/n1t0hrvmefnt50d_1520x1000.png',
        hint: (
          <div>
            <div>17种处置策略，智能匹配恢复方案，25%的设备故障问题无需线下修复，即可远程实现自愈。</div>
            <div style={{height: 8}}></div>
            <div>提供OTA升级能力，助力桩企实现远程修复异常、更新功能，提升设备兼容性。</div>
          </div>
        ),
        omega: {
          id: 'charge_cpcp_abilities4_tab3_sw',
          remark: '桩企平台首页_4售后降本_3设备故障自愈_曝光'
        }
      },
      {
        title: '模块级运维',
        href: 'https://view.didistatic.com/static/dcms/144p2r192kvmefnu8x5_1520x1000.png',
        hint: '联合行业头部模块厂家，打造智能化模块诊断能力，可实现模块数据线上化看清，助力桩企远程运维。',
        omega: {
          id: 'charge_cpcp_abilities4_tab4_sw',
          remark: '桩企平台首页_4售后降本_4模块级运维_曝光'
        }
      },
    ],
  },
  {
    title: '资金服务',
    subTitle: '灵活方便，安全可靠',
    children: [
      {
        title: '省心付',
        href: 'https://view.didistatic.com/static/dcms/144p2r192kvmefnuysw_1520x1000.png',
        hint: (
          <div> 
            <div>滴滴首创回款工具「省心付」，平台可从商户的经营收入中代扣设备采购款账期金额给到桩企。</div>
            <div style={{height: 8}}></div>
            <div>低门槛、无利率，降低桩企回款坏账风险，已累计撮合2.35亿元省心回款。</div>
          </div>
        ),
        omega: {
          id: 'charge_cpcp_abilities5_tab1_sw',
          remark: '桩企平台首页_5资金服务_1省心付_曝光'
        }
      },
      {
        title: '周转金',
        href: 'https://view.didistatic.com/static/dcms/n1t0hc9inmefnvhqf_1520x1000.png',
        hint: (
          <div>
            <div>滴滴充电联合金融机构，提前帮商户走完预授信，商户购桩随用随取，解决客户购桩资金问题。</div>
            <div style={{height: 8}}></div>
            <div>已经完成近亿元的提前授信，随时可用。</div>
          </div>
        ),
        omega: {
          id: 'charge_cpcp_abilities5_tab2_sw',
          remark: '桩企平台首页_5资金服务_2周转金_曝光'
        }
      },
    ],
  },
];

export const FOOTER_DATA = [
  {
    title: '快速链接',
    items: [
      { name: '滴滴充电', link: 'https://xjcd.didiglobal.com/' },
      { name: '小桔慧充', link: 'https://huichong.xiaojukeji.com/dashboard' },
      { name: 'Orange Unicorn', link: 'https://unicorn.xiaojukeji.com/' },
    ],
  },
  {
    title: '联系我们',
    items: [
      { name: '咨询热线：400 061 0999' },
      { name: '服务时间：7*24小时' },
      { name: '公司地址：浙江省杭州市余杭区仓前街道爱力中心B座5-8F' },
    ],
  },
];
